function isInside(point, el) {
  const { left, right, top, bottom } = el.getBoundingClientRect();
  const { x, y } = point;
  // console.log(left, right, top, bottom, x, y);
  return (left <= x && right >= x) && (top <= y && bottom >= y);
}

class DrawerEl extends HTMLElement {
  constructor() {
      super();

      this.activeEls = this.childNodes;
  }
  
  connectedCallback() {
      this.addEventListener('click', (ev) => {
          const point = {
              x: ev.x,
              y: ev.y
          };

          let isOpen = false;
          this.activeEls.forEach(el => {
              isInside(point, el) ? isOpen = true : null;
          });

          !isOpen ? this.close() : null;
      });
  }

  open() {
      document.querySelector('html').classList.add('drawer-open');
      this.classList.add('drawer-open');
  }

  close() {
      document.querySelector('html').classList.remove('drawer-open');
      this.classList.remove('drawer-open');
  }

}
  
class MobileMenu extends DrawerEl {
    constructor() {
      super();
      this.subContainer = this.querySelector('sub-menu-wrapper');
      this.openEl = document.querySelector('.mobile-navigation-for-search');
  
      this.isOpened = false;
  
      this.addAction();
    }
        
    addAction() {
      this.openEl.addEventListener('click', (ev) => {
          this.isOpened ? this.close() : this.open();
          console.log('click', this.isOpened);
          ev.preventDefault();
      });    
    }
  
    open() {
      let { top, height } = document.querySelector('#shopify-section-header-search').getBoundingClientRect();
      height += top;
      this.style.top = `${height}px`;
      this.style.height = `calc(100% - ${height}px)`;
      this.isOpened = true;
      this.openEl.classList.toggle('open', this.isOpened);
      super.open();
      console.log('open', this.isOpened);
    }
  
    close() {
        this.isOpened = false;
        this.openEl.classList.toggle('open', this.isOpened);
        this.subContainer.close();
        super.close();
        console.log('close', this.isOpened);
    }
  }
  window.customElements.define('mobile-menu', MobileMenu);
  
class SubMobileMeu extends HTMLElement {
    constructor() {
        super();
        this.trigger = this.dataset.triggerBy;
        this.triggerEl = document.querySelector(`[data-trigger=${this.trigger}]`);

        this.closeEl = this.querySelector('.close_submenu');

        this.openEv = new Event('Mobile:Sub:Open', {bubbles: true});
        this.closeEv = new Event('Mobile:Sub:Close', {bubbles: true});
    }

    connectedCallback() {
        this.triggerEl.addEventListener('click', () => {
            this.open();
        });

        this.closeEl.addEventListener('click', () => {
            this.close(true);
        })
    }

    open() {
        this.classList.add('opened');
        this.dispatchEvent(this.openEv);
    };

    close(parent=false) {
        this.classList.remove('opened');
        console.log(parent);
        parent ? this.dispatchEvent(this.closeEv) : null; 
    };
}
window.customElements.define('sub-mobile-menu', SubMobileMeu);

class SubMenuWrapper extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.addEventListener('Mobile:Sub:Open', this.open.bind(this));
        this.addEventListener('Mobile:Sub:Close', this.close);
    }

    open(ev) {
        let trigger = ev.target.dataset.triggerBy;
        this.classList.toggle('opened', true);
        this.querySelectorAll('sub-mobile-menu').forEach(submenu => {
            let m_trigger = submenu.dataset.triggerBy;
            trigger == m_trigger ? null : submenu.close();
        });
    }

    close() {
        this.classList.remove('opened');
    }
}
window.customElements.define('sub-menu-wrapper', SubMenuWrapper);


class TabElement extends HTMLElement {
	constructor() {
		super();
		this.activeStatus = false;

		this.triggerEl = this.querySelector('.tab-name');
		this.contentEl = this.querySelector('.tab-content');

		this.activeEv = new Event('tab:active', {bubbles: true});
		this.inActiveEv = new Event('tab:inactive', {bubbles: false});
	}

	connectedCallback() {
		this.triggerEl.addEventListener('click', () => {
			this.activeStatus = !this.activeStatus;
			this.classList.toggle('is-opened', this.activeStatus);
			this.activeStatus ? this.dispatchEvent(this.activeEv) : this.dispatchEvent(this.inActiveEv);
		});

		this.addEventListener('tab:inactive', () => {
			this.activeStatus = false;
			this.classList.toggle('is-opened', this.activeStatus);
		});

		this.classList.toggle('is-opened', this.activeStatus);
	}
}
window.customElements.define('tab-element', TabElement) ;
	
class TabWrapper extends HTMLElement {
	constructor() {
		super();
		this.tabs = this.querySelectorAll('tab-element');
	}

	connectedCallback() {
		this.addEventListener('tab:active', this.updateTab.bind(this));
	}

	updateTab(ev) {
		const activeEl = ev.target;
		let dataTab = activeEl.dataset.tab;
		Array.from(this.tabs).filter(tab => tab.dataset.tab != dataTab).forEach(tab => tab.dispatchEvent(tab.inActiveEv));
	}
}
window.customElements.define('tab-wrapper', TabWrapper);
